import React, { useEffect, useState } from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { ContentTemplate } from 'web-library';
import OpsAdminForm, {
  IOpsAdminData,
} from '../../../examRegistration/components/nonNationalExam/OpsAdminForm';
import OpsAdminButton from '../../../examRegistration/components/nonNationalExam/OpsAdminButton';
import { useUpdateApplication } from '../../../examRegistration/logic/useUpdateApplication';

const useStyles = makeStyles()((theme) =>
({
  container: {
    alignItems: 'center',
  },
  errorText: {
    color: theme.color.state.stateError,
    marginBottom: theme.spacing(2),
  },
  dialogBold: {
    fontWeight: 'bold',
  },
  paymentButton: {
    padding: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  tableCaption: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(24),
  },
  examFeeDetails: {
    paddingBottom: theme.spacing(6),
  },
  selectedSubjects: {
    paddingTop: theme.spacing(6),
  },
  amendmentError: {
    marginBottom: theme.spacing(3),
  },
  subheader: {
    marginBottom: theme.spacing(6),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
  inputSection: {
    marginBottom: theme.spacing(4),
  },
  viewLog: {
    marginTop: theme.spacing(6),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      paddingLeft: 0,
    },
  },
  bottomButtonGroup: {
    marginBottom: theme.spacing(7),
  },
  twinButtonGroup: {
    marginBottom: theme.spacing(4),
  },
}));

interface IOpsAdminFormProps {
  formData: IOpsAdminData;
  handleOpenAuditLog: (e: any) => void;
  isLoadingLastUpdated: boolean;
  hasEditAccess: boolean;
}

const ApplicationReviewForm = (props: IOpsAdminFormProps) => {
  const { t } = useTranslation();
  const { formData, handleOpenAuditLog, isLoadingLastUpdated, hasEditAccess } = props;
  const [disableButton, setDisableButton] = useState(false);
  const { classes } = useStyles();

  const appStatusDefaultValue =
    formData?.applicationStatusDropdown?.find(
      (d) => d.code === formData?.applicationStatusData?.status
    ) || undefined;

  const { formHook } = useUpdateApplication({
    formDefaultValues: {
      applicationStatus: appStatusDefaultValue || undefined,
      internalRemarks: formData?.applicationStatusData.internalRemark || '',
      candidateRemarks: formData?.applicationStatusData.candidateRemark || '',
    },
  });

  const { formState } = formHook;

  useEffect(() => {
    setDisableButton(!formState.isDirty);
  }, [formState.isDirty]);

  return (
    <>
      <ContentTemplate isContinuable type="full">
        <OpsAdminForm
          formData={formData}
          classes={classes}
          handleOpenAuditLog={handleOpenAuditLog}
          t={t}
          formHook={formHook}
          isLoadingLastUpdated={isLoadingLastUpdated}
          hasEditAccess={hasEditAccess}
        />
      </ContentTemplate>
      <OpsAdminButton
        formData={formData}
        classes={classes}
        t={t}
        formHook={formHook}
        disableButton={disableButton}
        hasEditAccess={hasEditAccess}
      />
    </>
  );
};

export default ApplicationReviewForm;
